export default __webpack_public_path__ + "src/images/packages/bundox-safari-lodge/7c27b474da36450e139e7c748341bdd8-4.jpg";